import { render, staticRenderFns } from "./Activity3.vue?vue&type=template&id=03155fd6&scoped=true"
import script from "./Activity3.vue?vue&type=script&lang=js"
export * from "./Activity3.vue?vue&type=script&lang=js"
import style0 from "./Activity3.vue?vue&type=style&index=0&id=03155fd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03155fd6",
  null
  
)

export default component.exports